export function createMenuController({ menuPanel, menuToggleButton, closeNodeMenus, onClose = null }) {
  function setMenuOpen(isOpen) {
    menuPanel.hidden = !isOpen;
    menuToggleButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (isOpen) {
      closeNodeMenus();
    } else if (onClose) {
      onClose();
    }
  }

  function toggleMenu() {
    setMenuOpen(menuPanel.hidden);
  }

  return { setMenuOpen, toggleMenu };
}
